<script setup lang="ts">
const {
  month = 0,
  year = 0,
  months,
  years,
} = defineProps<{
  month?: number
  year?: number
  months: { value: number; text: string }[]
  years: { value: number; text: string }[]
}>()

const emit = defineEmits(['update:month', 'update:year', 'closeMonthOverlay'])

const { handleToggleOverlay } = inject('toggleOverlay')

function selectMonth(month) {
  emit('closeMonthOverlay')
  emit('update:month', month)
  handleToggleOverlay(false)
}

function onMonthsPrev() {
  const minYear = years[0].value
  const newYear = year === minYear ? year : year - 1

  if (newYear !== year)
    emit('update:year', newYear)
}

function onMonthsNext() {
  const maxYear = years[years.length - 1].value
  const newYear = year === maxYear ? year : year + 1

  if (newYear !== year)
    emit('update:year', newYear)
}
</script>

<template>
  <div class="dp__overlay p-5 rounded-xl px-4">
    <div class="dp__overlay_container flex">
      <div class="flex justify-between items-center capitalize font-semibold">
        <AppIcon
          class="
            hover:bg-primary hover:bg-opacity-15
            cursor-pointer
            px-5
            py-4.5
            rounded-xl
            text-primary
          "
          icon="angle-left"
          type="far"
          @click="onMonthsPrev"
        />
        <span
          class="
            hover:bg-primary hover:bg-opacity-15
            py-2.5
            px-4
            cursor-pointer
            rounded-xl
            flex
          "
          @click="emit('closeMonthOverlay')"
        >
          {{ year }}

          <AppIcon class="text-primary ml-2" icon="angle-up" type="far" />
        </span>
        <AppIcon
          class="
            hover:bg-primary hover:bg-opacity-15
            cursor-pointer
            px-5
            py-4.5
            rounded-xl
            text-primary
          "
          icon="angle-right"
          type="far"
          @click="onMonthsNext"
        />
      </div>

      <div class="flex flex-wrap gap-y-2.5 font-medium">
        <div
          v-for="(monthItem, index) in months"
          :key="`datepicker-month-${index}`"
          class="basis-1/3 flex-grow-0 flex-shrink-0 flex justify-center"
        >
          <span
            class="
              capitalize
              cursor-pointer
              px-2.5
              py-2
              rounded-lg
              hover:bg-primary hover:bg-opacity-15
            "
            :class="{ 'border border-primary ': month === monthItem.value }"
            @click="selectMonth(monthItem.value)"
          >
            {{ monthItem.text }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
